<template>
    <v-toolbar dark dense flat height="80">
      <v-toolbar-title class="white--text pa-5 text-center" color="white" to="/home" style="font-family: 'Roboto', cursive; font-size: 40px">SIMFIC 2.0<span class="pl-5" color="white">Ground</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small light color="primary" class="ml-1" to='/home'><v-icon small left>house</v-icon><span class="py-auto"><b>Home</b></span></v-btn>
      <tour></tour>
      <!-- Drop down -->
        <v-menu offset-y >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            class="ml-1"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small left>call_split</v-icon>
            System
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
          >
            <v-list-item-title><a :href="`${item.url}`" target="blank">{{ item.title }}</a></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- Drop down ends -->
      <!-- Drop down -->
        <v-menu offset-y >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            class="ml-1"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small left>call_split</v-icon>
            Feedback
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in feed"
            :key="index"
          >
            <v-list-item-title><a :href="`${item.url}`" target="blank">{{ item.title }}</a></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- Drop down ends -->
      <!-- <v-btn small light color="primary" class="ml-1" target='__blank__' href='https://simfic-feed.firabaseapp.com'><v-icon small left>feedback</v-icon><span class="py-auto"><b>Feedback</b></span></v-btn> -->

    </v-toolbar>
</template>


<script>

import navi from '@/assets/images/abg.png';
import tour from '@/components/tour.vue';
    export default {
        name: "Navigation",
        computed: {
          
        },
        data() {
          return {
            navi: navi,
            items: [
              { title: 'SimFic-Sky' , url: 'https://simfic2sky.firebaseapp.com/'},
              { title: 'SimFic-Horizon', url: 'https://simfic2horizon.firebaseapp.com/' },
              { title: 'SimFic-Ground', url: 'https://simfic2ground.firebaseapp.com/' },
              
            ],
            feed: [
              { title: 'Feedback(English)', url: 'https://docs.google.com/forms/d/e/1FAIpQLSeO2uCsyQpm4ASIAwJMA0j36s-cYuCaJ-u0i1bOl3ssSwkQ2g/viewform?usp=sf_link' },
              { title: 'Feedback(German)', url: 'https://docs.google.com/forms/d/e/1FAIpQLSdoNJI3jTMvfK9Kupvbnxr3hiG18EllEN10MpLAbPLFY6SSxQ/viewform?usp=sf_link' }
            ]
          }
        },
        components: {
          tour
        }
    }
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

</style>